import { parseQueryString } from '@hex/shared/utils';
import { PropertyType } from '../types/affordability';

enum HemnetPropertyType {
  Estate = 'estate',
  Condominium = 'condominium',
}

type HemnetQueryParams = {
  /** Property Type */
  boendetyp: string;
  /** Property Price */
  pris: string;
  /** Monthly Fee */
  manadsavgift: string;
  /** Monthly Running Cost */
  driftkostnad: string;
};

export const mapHemnetPropertyType: {
  [key: string]: PropertyType;
} = {
  [HemnetPropertyType.Estate]: PropertyType.Villa,
  [HemnetPropertyType.Condominium]: PropertyType.Apartment,
};

export function getHemnetQueryParams(): HemnetQueryParams {
  return parseQueryString(window.location.search);
}
